import { Component, Input, Output, EventEmitter } from '@angular/core';
import { AtividadeVisualizacao } from './atividade-visualizacao';
import { visualizacaoModoCalendar, isVisualizacaoModoCalendar, visualizacaoModoList, isVisualizacaoModoList } from '../../../common/visualizacao-modo';

@Component({
    selector: 'sgt-atividade-visualizacao',
    templateUrl: './atividade-visualizacao.component.html',
    styleUrls: ['./atividade-visualizacao.component.less']
})
export class AtividadeVisualizacaoComponent {
    visualizacaoModos = [visualizacaoModoCalendar, visualizacaoModoList];

    @Input() visualizacao: AtividadeVisualizacao;
    @Output() changeModo = new EventEmitter<void>();

    /** Ao alterar o modo de visualização */
    onChangeVisualizacaoModo(modo: number) {
        this.visualizacao.modo = modo;
        setTimeout(() => this.changeModo.emit(), 0);
    }

    /** Verifica se o modo de visualização selecionado é o modo Calendar */
    isModoCalendar(): boolean {
        return isVisualizacaoModoCalendar(this.visualizacao?.modo);
    }

    /** Verifica se o modo de visualização selecionado é o modo List */
    isModoList(): boolean {
        return isVisualizacaoModoList(this.visualizacao?.modo);
    }
}
